module.exports = __webpack_public_path__ + "static/media/reddit.a06d6763.png";